export { default as InlineRedirect } from './InlineRedirect';